import { render, staticRenderFns } from "./BaseTransferSelect.vue?vue&type=template&id=0a6d0dd9&scoped=true"
import script from "./BaseTransferSelect.vue?vue&type=script&lang=js"
export * from "./BaseTransferSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseTransferSelect.vue?vue&type=style&index=0&id=0a6d0dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d0dd9",
  null
  
)

export default component.exports